export default {

    getApiVersion(state) {
        return state.apiVersion;
    },

    getEnvType(state) {
        return state.envType;
    },

    getMenuStatus(state) {
        return state.isMenuOpen;
    },

    getTaxonomies(state) {
        return state.taxonomies;
    },

    getTermsByTaxonomy: (state, getters) => (taxonomy) => {
        return state.taxonomies[taxonomy];
    },

    getCurrentCatalog(state) {
        return state.catalogData;
    },

    getCatalogId(state) {
        return state.catalogData.id;
    },

    getCatalogName(state) {
        return state.catalogData.displayName;
    },

    getEquipmentCatalogId(state) {
        return state.equipmentCatalogData.id;
    },

    getTermsByTaxonomyRaw: (state, getters) => (taxonomy) => {

        let found = "";
        state.taxonomiesRaw.forEach(function(tax) {
            if(tax.name == taxonomy) {
                found = tax.taxonomyTerms;
                return;
            }
        });

        return found;

    },

    getUser(state) {
        return state.user;
    },

    getUserRole(state) {
        return state.user != null ? state.user.userRole : null;
    },

    isExternal(state) {
        return state.isExternal;
    },

    isLoggedIn(state) {
        return state.loggedIn;
    },

    isModalOpen(state) {
        return state.modalIsOpen;
    },

    isLoading(state) {
        return state.isLoading;
    },

    isOldIEVersion(state) {
        return state.isOldIEVersion;
    },

    getCatalogPagesTotal(state) {
        return state.catalogPagesTotal;
    },

    getIndustryPartnerCatalogPages(state) {
        return state.industryPartnerCatalogPages;
    },

    getRedirectURL(state) {
        return state.redirectURL;
    },

    getCatalogFilter: (state, getters) => (type) => {
        return state.activeFilter.catalog[type] ? state.activeFilter.catalog[type] : null;
    },
    getPharmaciesFilter: (state, getters) => (type) => {
        return state.activeFilter.pharmacies[type] ? state.activeFilter.pharmacies[type] : null;
    },
    getProductsFilter: (state, getters) => (type) => {
        return (state.activeFilter.products[state.user.id] || {})[type] ? (state.activeFilter.products[state.user.id] || {})[type] : null;
    },
    getEquipmentsFilter: (state, getters) => (type) => {
        return state.activeFilter.equipments[type] ? state.activeFilter.equipments[type] : null;
    },
    getEquipmentCatalogFilter: (state, getters) => (type) => {
        return state.activeFilter.equipmentCatalog[type] ? state.activeFilter.equipmentCatalog[type] : null;
    },
    getContentPoolFilter: (state, getters) => (type) => {
        return typeof state.activeFilter.contentPool != 'undefined' && state.activeFilter.contentPool[type] ? state.activeFilter.contentPool[type] : null;
    },

    getPIMFilter(state) {
        return typeof state.activeFilter.pim != 'undefined' ? state.activeFilter.pim : null;
    },

    getPIMPharmacy(state) {
        return typeof state.pimPharmacy != 'undefined' && state.pimPharmacy != null ? state.pimPharmacy : null;
    },

    getCurrentPimTablePage(state) {
        return state.currentPimTablePage;
    },

    getPimProductPageTitle(state) {
        return state.pimProductPageTitle;
    }

}